import { render, staticRenderFns } from "./addFaceDatabase.vue?vue&type=template&id=ce38f978&"
import script from "./addFaceDatabase.vue?vue&type=script&lang=js&"
export * from "./addFaceDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports